module.exports = "\n<p>\n  dashboard works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/seller/homedashboard/homedashboard.component.html
// module id = ./src/app/seller/homedashboard/homedashboard.component.html
// module chunks = main